import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IFile, INameRef, IPatchRequest, IPatchResponse, ITemplateField } from '@leandredev/dcbm-common-lib/dist/interfaces';
import { IAdminChat, _parseExtendedRequestMessage, defaultType } from '../utils';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Subscription, catchError, filter, from, map, of } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { interfaces as I } from '@leandredev/dcbm-common-lib';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { BaseComponent } from '@leandredev/common_ng_14';
import { FileService } from 'src/app/services/file/file.service';
import dayjs from 'dayjs';

interface IMessage extends I.IMessage {
  data?: IPatchResponse;
}

@Component({
  selector: 'app-chat-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class ChatMessageComponent extends BaseComponent implements OnInit {
  @Input() message: IMessage;
  @Input() activeChat: IAdminChat;

  @Input() picture: IFile;
  @Input() closeChat: EventEmitter<boolean>;

  @Output() validateDevice: EventEmitter<I.IDeviceActivationRequest> = new EventEmitter<I.IDeviceActivationRequest>();

  constructor(private router: Router, private snackBar: MatSnackBar, private http: HttpClient, private fileService: FileService) {
    super();
  }

  public ngOnInit() {
    this.parseMessagesData(this.message);
  }

  public openDataEditor(data: IPatchRequest): void {
    const defaultTypes: defaultType[] = Object.keys(environment.data.defaultTypes).map((r) => environment.data.defaultTypes[r] as defaultType);

    if (data.act?.type) {
      const typeRef: INameRef = data.act.type as INameRef;
      const type = defaultTypes.find((o) => o.id === typeRef.ref);

      let url = '';

      if (type.class && data.act) {
        url = `/data/${type.class}/edit/${data.act.ref}`;
      } else {
        url = `/data/Act/edit/${data.act.ref}`;
      }

      from(this.router.navigate([url])).subscribe(() => {
        this.closeChat.emit(false);
      });
    } else {
      this.snackBar.open('Une erreur est survenue...', '×', {
        panelClass: 'success',
        verticalPosition: 'bottom'
      });
    }
  }

  public validateDeviceActivation(data: I.IDeviceActivationRequest): void {
    this.validateDevice.emit(data);
  }

  public isDeviceActivationRequest(message: IMessage): boolean {
    return message._class === 'DeviceActivationRequest';
  }

  public parseMessagesData(message: IMessage): void {
    if (message.data?._class == 'PatchResponse' && message.data?.field) {
      const data = this.message.data as IPatchResponse;
      data.field['_value'] = _parseExtendedRequestMessage(this.message.data as IPatchResponse);
    }
  }

  public isLeaf(field: ITemplateField): boolean {
    return !['ParameterComponent', 'ParameterComponentList', 'ParameterTab', 'ParameterGroup'].includes(field._class);
  }
  public cancelDownload(): void {
    if (this.downloadSub && !this.downloadSub.closed) {
      this.downloadSub.unsubscribe();
      this.downloadSub = null;
      this.downloading = false;
    }
  }

  public downloading = false;

  public downloadSub: Subscription;

  public openFilefromCLient(): void {
    const userName = this.activeChat.profile.name;
    const date = dayjs(this.message.seenAt).format('DDMMYYYY:HH-MM');

    const fileName = [userName, date].join('-').concat('.pdf');

    this.downloading = true;
    this.downloadSub = this.fileService
      .downloadUserClientFile(this.message.attachedFile)
      .pipe(
        filter((event: HttpResponse<Blob>) => event.type === HttpEventType.Response),
        map((response) => {
          if (response.status !== 200) throw new Error('missign file');
          return response.body;
        }),
        map((blob) => {
          const a = document.createElement('a');
          const objectUrl = window.URL.createObjectURL(blob);
          a.href = objectUrl;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(objectUrl);
        }),
        catchError((error) => {
          this.snackBar.open('Une erreur est survenue...', '×', {
            panelClass: 'success',
            verticalPosition: 'bottom'
          });

          console.error(error);

          return of(null);
        })
      )
      .subscribe(() => (this.downloading = false));

    this.subscription.add(this.downloadSub);
  }
}
